import { useQuery } from '@tanstack/react-query';

import { type Medical } from '~entities/student/modal/medical';
import {
  type Attendance,
  type Enrollment,
  type Event,
} from '~entities/student/modal/student';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface Student {
  __v: number;
  _id: string;
  createdAt: string; // ISO date string
  dob: string; // ISO date string
  enrollments?: Array<Enrollment>;
  events?: Array<Event>;
  gender: string;
  medical: Medical;
  mobileNo: string;
  name: string;
  firstName: string;
  lastName: string;
  parentId: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  studentEmail: string;
  studioId: string;
  tShirtSize: string;
  transportation: string;
  updatedAt: string; // ISO date string
  familyName: string;
  profilePicUrl: string;
  attendance: Array<Attendance | null>;
}

export const getStudentFullDetailsById = async (studentId: string) => {
  const response = await baseAPI.get<Student>(`/students/${studentId}/details`);
  return response.data;
};

export const useGetStudentFullDetailsById = (
  { studentId }: { studentId: string },
  { enabled = true } = {},
) => {
  return useQuery({
    queryKey: [KEYS.STUDENTS, studentId],
    queryFn: () => getStudentFullDetailsById(studentId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });
};
